import { colors } from './colors';
/**
 * The elevation scale for the design system.
 */
const boxShadow = {
  // Tailwind's default `shadow-none`, redeclared because this map is installed
  // at the TOP LEVEL of the Tailwind theme and replaces the default scale —
  // without it `.shadow-none` (e.g. disabled treatments) compiles to nothing.
  none: '0 0 #0000',
  xs: '0px 1px 2px 0px rgba(10, 13, 18, 0.05)',
  sm: '0 2px 4px rgba(0, 0, 0, 0.25)',
  md: '0 4px 8px rgba(0, 0, 0, 0.25)',
  lg: '0 8px 16px rgba(0, 0, 0, 0.25)',
  // Same spread as `lg` at a lighter opacity, for surfaces that should float without weight.
  'lg-soft': '0 8px 16px rgba(0, 0, 0, 0.08)',
  xl: '0 16px 24px rgba(0, 0, 0, 0.25)',
  'no-top': '0px 11px 7px 0px rgba(0, 0, 0, 0.05), 0px 5px 5px 0px rgba(0, 0, 0, 0.09)',
  'inset-skeumorphic': '0px -2px 0px 0px rgba(10, 13, 18, 0.05) inset',
  'inset-skeumorphic-border': '0px 0px 0px 1px rgba(10, 13, 18, 0.18) inset',
  'radio-button-selected': `0px 0px 0px 2px ${colors.brand['500']}`,
  'radio-button-selected-disabled': `0px 0px 0px 2px ${colors['gray-utility']['300']}`,
  'radio-button-focused': `0px 0px 0px 2px ${colors.white}, 0px 0px 0px 4px ${colors.brand['500']}`,
  // Hover Action button focus ring (spec: inner 2px white separator, outer 4px
  // purple). #9E77ED comes straight from the spec — it has no match in the
  // color scales, so it lives here as a literal until design maps it.
  'hover-action-button-focused': `0px 0px 0px 2px ${colors.white}, 0px 0px 0px 4px #9E77ED`,
};

export { boxShadow };
